<template>
  <b-form-group
    label="Ürün Kodu"
    label-for="pcode"
  >
    <validation-provider
      #default="{ errors }"
      name="Ürün Kodu"
      :rules="autoCode? null : 'required'"
    >
      <b-input-group>
        <b-form-input
          id="pcode"
          v-model="dataItem.pcode"
          :placeholder="autoCode ? 'Otomatik oluşturulur' : 'Ürün Kodu'"
          :disabled="autoCode"
          @input="checkCode"
        />
        <b-input-group-append
          v-b-tooltip.hover
          is-text
          title="Otomatik Oluştur"
        >
          <b-form-checkbox
            v-model="autoCode"
            @change="resetCode"
          />
        </b-input-group-append>
      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BFormCheckbox, VBTooltip,
} from 'bootstrap-vue'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'ProductsScodeCard',
  components: {
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      autoCode: false,
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['products/dataItem']
    },
  },
  created() {
    localize('tr')
  },
  methods: {
    resetCode() {
      this.dataItem.pcode = null
    },
    checkCode() {
      if (this.dataItem.pcode) {
        this.$store.dispatch('products/checkCode', {
          pcode: this.dataItem.pcode,
          id: this.dataItem.id,
        })
          .then(res => {
            if (!res.status) {
              this.showToast({
                title: 'Geçersiz Kod!',
                icon: 'XCircleIcon',
                text: res.message,
                variant: 'danger',
              })
            }
          })
      }
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'top-right',
      })
    },
  },
}
</script>
